/* lib/workspace.js — отображаемое имя пространства.
   Личное (kind=personal) показываем как «Моё пространство» (имя ws на бэке = ФИО
   владельца). Единый источник для всех переключателей пространств (сайдбар + mobile «Ещё»). */

export function workspaceName(ws) {
  if (!ws) return '';
  if ((ws.kind || 'personal') === 'personal') return 'Моё пространство';
  return ws.name;
}
